import heic2any from 'heic2any';

export const convertToJpeg = async (file: Blob) => {
    const convertedBlob = await heic2any({
        blob: file,
        toType: 'image/jpeg',
    });
    return convertedBlob;
};
